import { MoreHorizontalIcon } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button.js';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu.js';

export interface QualityRunMenuAction {
  id: string;
  label: string;
  icon?: ReactNode;
  destructive?: boolean;
  onSelect: () => void;
}

/** The run keeps one action in reach; secondary and destructive actions stay in its menu. */
export function QualityRunActionsMenu({
  actions,
  menuVisible = true,
}: {
  actions: QualityRunMenuAction[];
  menuVisible?: boolean;
}) {
  const primary = actions.find((action) => !action.destructive);
  const remaining = actions.filter((action) => action !== primary);
  const secondary = [
    ...remaining.filter((action) => !action.destructive),
    ...remaining.filter((action) => action.destructive),
  ];
  if (!actions.length) return null;
  return (
    <div data-run-actions className="flex items-center gap-2">
      {primary && (
        <Button variant="outline" size="sm" onClick={primary.onSelect}>
          {primary.icon}
          {primary.label}
        </Button>
      )}
      {secondary.length > 0 && menuVisible && (
        <DropdownMenu modal={false}>
          <DropdownMenuTrigger asChild>
            <Button
              variant="ghost"
              size="icon-sm"
              aria-label="More run actions"
              title="More run actions"
            >
              <MoreHorizontalIcon aria-hidden className="size-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            {secondary.map((action) => (
              <DropdownMenuItem
                key={action.id}
                onSelect={action.onSelect}
                className={action.destructive ? 'text-destructive' : undefined}
              >
                {action.icon}
                {action.label}
              </DropdownMenuItem>
            ))}
          </DropdownMenuContent>
        </DropdownMenu>
      )}
    </div>
  );
}
